angular
  .module("additionalDocumentation.components", [])
  .component("additionalDocumentation", {
    templateUrl: "ng/components/additionalDocumentation/additionalDocumentation.view.html",
    bindings: {
      appCustomer: "<",
      privacy: "=",
      formaGiuridica: "<",
      idNumber: "<",
      isFinancial: "@",
      onPrivacyOk: "&?",
      onPrivacyNotOk: "&?",
      instantModel: '='

    },
    controllerAs: "additionalDocumentationCtrl",
    controller: function additionalDocumentationController(
      $rootScope,
      $timeout,
      $configService,
      $giuridicVersion,
      FileUploader,
      $typeDomainService,
      $download,
      $transactionFactory
    ) {
      var self = this;

      self.$giuridicVersion = $giuridicVersion;
      (self.privacy = {
        downloaded: false,
        documentoPrivacyFirmato: {},
        moduleCode: "",
        subscritionDate: null,
        validityEndDate: null,
        listaConsensi: [],
        writeToNsil: false,
        index: null
      }),
        (self.loadingStatus = {
          uploading: false,
          loadingDataFromCerved: false,
          savedDataFromCerved: false,
          loading: false,
          loadingAddressesList: false,
          loadingPfList: false,
          insertingContract: false
        });

      self.$onInit = function () {
        //self.privacy = self.privacy || null;
        self.title = "TITLE_DOCUMENTATION";
        self.isCorrectedPractise = self.isCorrectedPractise ? true : false;
        self.disableInput = false;
        self.formaGiuridica = self.formaGiuridica || null;
        self.idNumber = self.idNumber || null;
        self.progresso = 0;
        self.visualProgBar = false;
        self.responseTable = 0;
        self.uploadOk = false;
        self.cecked = false;
        self.documentUpload = [];

        self.privacy = self.privacy;


        $typeDomainService.getDomainSet('RI_UPLOAD_IL', 'OTHERDOCS')
          .then(function (response) {
            self.responseTable = response.domainList;
          })
          .catch(function (error) {
            console.log("error: ", error);
          })
          .finally(function () {

          });

        if (self.instantModel &&
          self.instantModel.documentazioneAggiuntiva &&
          self.instantModel.documentazioneAggiuntiva.listaDoc &&
          self.instantModel.documentazioneAggiuntiva.listaDoc.length > 0) {
          self.documentUpload = self.instantModel.documentazioneAggiuntiva.listaDoc;
          self.checkPrivacy();
        }

        if (self.isCorrectedPractise) {
          self.title = "LBL_TEXT_INTEGRATE_DOCUMENTATION"
          self.MetadataAppContractManualSignatureUploadDoc = $transactionFactory.get();
          self.textError = self.MetadataAppContractManualSignatureUploadDoc.metadataAppContractManualSignatureUploadDoc.errorMessage;

        }


      };

      self.uploadDataFunc = function (item, index, privacy) {
        var document =
          arguments.length > 3 && arguments[3] !== undefined ?
            arguments[3] :
            false;
        if (item) {
          self.uploadData = item;
        }
        self.isPrivacyUpload = privacy;
        self.uploadDocumenti = document;
        self.currentCodeTypeNameIndex = index;
      };

      self.uploader = new FileUploader({
        url: "",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
          "App-Name": $rootScope.portalName
        }
      });

      self.finalUpload = function (item) {
        console.log("calling finalUpload");
        self.folderPath = "" + new Date().getTime();
        var url;
        if (self.isFinancial) {
          url =
            $configService.getAppConfig().url +
            "/uni/upload/service-infos/" +
            encodeURIComponent(self.idNumber) +
            "/" + self.responseTable[0].value + "/IL";

        } else {
          if (self.isPrivacyUpload) {
            url =
              $configService.getAppConfig().url +
              "/simulator/upload/service-infos/" +
              encodeURIComponent(self.idNumber) +
              "/PRIVACY/";
          } else {
            url =
              $configService.getAppConfig().url +
              "/simulator/upload/service-infos/" +
              encodeURIComponent(self.idNumber) +
              "/" +
              item.code +
              "/";
          }
        }
        for (var int = 0; int < self.uploader.queue.length; int++) {
          self.uploader.queue[int].url = url;
        }
        self.loadingStatus.uploading = true;
        self.uploader.uploadAll();
      };

      self.generateDownloadLink = function (filename) {
        var url =
          "/uni/download/service-infos/" +
          encodeURIComponent(self.idNumber) +
          "/052/" +
          filename +
          "/IL/"

        $download.getGenericDownload(url)
          .then(function (response) {
            console.log(response);
          })

      };

      self.uploader.onWhenAddingFileFailed = function (
        item /*{File|FileLikeObject}*/,
        filter,
        options
      ) {
        console.info("onWhenAddingFileFailed", item, filter, options);
      };

      self.uploader.onAfterAddingFile = function (fileItem) {
        console.log("fileItem", fileItem);
        if (fileItem.file.size > 26214400) {
          $rootScope.$broadcast("addAlert", {
            text: "MAXIMUM_FILE_SIZE_EXCEEDED"
          });
          fileItem.remove();
          $("#input-upload-" + self.currentCodeTypeNameIndex).val("");
        }
        var fileName = fileItem.file.name;
        if (
          fileName.toLowerCase().indexOf(".pdf") > -1 ||
          fileName.toLowerCase().indexOf(".png") > -1 ||
          fileName.toLowerCase().indexOf(".jpg") > -1 ||
          fileName.toLowerCase().indexOf(".jpeg") > -1 ||
          fileName.toLowerCase().indexOf(".p7m") > -1
        ) {
          // $timeout(function () {
          //   self.visualProgBar = true;
          // }, 500);
          self.uploader.queue[0].progress = 100;
          self.visualProgBar = true;
          $timeout(function () {
            self.progresso = 100;
          }, 500);
        } else {
          fileItem.remove();
          $("#input-upload-" + self.currentCodeTypeNameIndex).val("");
          $rootScope.$broadcast("addAlert", {
            text: "FORMAT_NOT_SUPPORTED"
          });
        }
      };

      self.uploader.onAfterAddingAll = function (addedFileItems) {
        console.info("onAfterAddingAll", addedFileItems);
        self.finalUpload(self.uploadData);
      };

      self.uploader.onBeforeUploadItem = function (item) {
        item.file.name = window.encodeURIComponent(item.file.name);
        item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
        self.disableInput = true;
      };

      self.uploader.onProgressItem = function (fileItem, progress) {
        self.uploadCompleted = false;
      };

      self.uploader.onProgressAll = function (progress) { };

      self.uploader.onSuccessItem = function (
        fileItem,
        response,
        status,
        headers
      ) {
        self.loadingStatus.uploading = false;
      };

      self.uploader.onErrorItem = function (
        fileItem,
        response,
        status,
        headers
      ) {
        console.info("onErrorItem", fileItem, response, status, headers);
        self.loadingStatus.uploading = false;
        $("#input-upload-" + self.currentCodeTypeNameIndex).val("");
        $rootScope.$broadcast("addAlert", {
          text: "ERROR_UPLOADING_FILE"
        });
        self.checkPrivacy();
        self.disableInput = false;
        $timeout(function () {
          self.visualProgBar = false;
        }, 4000);

        fileItem.remove();

      };

      self.uploader.onCancelItem = function (
        fileItem,
        response,
        status,
        headers
      ) { };

      self.uploader.onCompleteItem = function (
        fileItem,
        response,
        status,
        headers
      ) {
        console.info("onCompleteItem", fileItem, response, status, headers);
        if (response && response.uploadFileServicePojo && response.uploadFileServicePojo.success) {
          self.uploadOk = true;
          console.log(fileItem);
          self.privacy.documentoPrivacyFirmato = {
            selected: false,
            nameFile: response.uploadFileServicePojo.fileName,
            success: response.uploadFileServicePojo.success
          };
          var temp = {
            name: response.uploadFileServicePojo.fileName,
            selected: false,
            tipo: "Documento Aggiuntivo"
          }
          self.documentUpload.push(temp);
          self.documentUpload = self.documentUpload.filter(function (elem) {
            return elem.name != "";
          })
          if (!self.isFinancial) {
            if (self.isPrivacyUpload) {
              self.privacy.documentoPrivacyFirmato = {
                selected: false,
                nameFile: response.fileName
              };
            }
          }
        }
        self.uploader.queue = [];
        self.checkPrivacy();
        self.disableInput = false;
        $timeout(function () {
          self.visualProgBar = false;
        }, 4000);
        $('#uploadInput_0').val('');
      };

      self.uploader.onCompleteAll = function () {
        console.info("onCompleteAll");
        self.uploadCompleted = true;
      };

      self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
        self.uploading = false;
      };

      self.consensiPrivacy = function () {
        self.esito = true;
        if (self.featureService.NewPrivacy()) {
          self.raccoltaInfo.privacy.listaConsensi &&
            self.raccoltaInfo.privacy.listaConsensi
              .filter(function (consenso) {
                return consenso.obbligatorio;
              })
              .forEach(function (consensoObbligatorio) {
                if (
                  consensoObbligatorio.esito == "false" ||
                  consensoObbligatorio.esito == false
                ) {
                  self.esito = false;
                }
              });
        }
        return self.esito;
      };

      self.deletePrivacyDocument = function () {
        self.progresso = 100;
        self.visualProgBar = true;
        $timeout(function () {
          self.progresso = 0;

        }, 200);

        self.documentsToBeDeleted = self.documentUpload.filter(function (elem) {
          return elem.selected == true;
        });

        var documentRow =
          arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        self.privacy.documentoPrivacyFirmato = {};


        self.documentsToBeDeleted.forEach(function (element) {
          var type = 'IL'; //tipo di cancellazione es. IL – PERSONAL_DOCUMENT
          var idObject = self.idNumber; // cf  oppure idWfInstance
          var codiceDocNsil = '052'; //es: 052
          var fileName = element.name; //nome del file

          $typeDomainService.deleteFile(type, idObject, codiceDocNsil, fileName)
            .then(function (response) {
              console.log(response);
              self.documentUpload = self.documentUpload.filter(function (elem) {
                return elem.selected != true;
              })
              self.checkPrivacy();
            })
            .catch(function (error) {
              $rootScope.$broadcast('addAlert', {
                text: 'ERROR_TEC'
              });
            })
            .finally(function () {

              $timeout(function () {
                self.visualProgBar = false;
                self.uploadOk = false;
              }, 4000);
            })
        })


      };

      self.check = function (el) {
        el.selected = !el.selected;
      };

      self.checkPrivacy = function () {

        if (!!!self.privacy) {
          return;
        }
        if (!self.isFinancial) {


          var ok =
            self.privacy &&
            self.privacy.listaConsensi
              .filter(function (consenso) {
                return !!consenso.obbligatorio;
              })
              .every(function (consensoObbligatorio) {
                return consensoObbligatorio.esito === true;
              }) &&
            self.privacy.documentoPrivacyFirmato &&
            self.privacy.documentoPrivacyFirmato.nameFile;

          if (ok) {
            self.onPrivacyOk && self.onPrivacyOk();
          } else {
            self.onPrivacyNotOk && self.onPrivacyNotOk();
          }
        } else {
          var ok = self.documentUpload.length;
          if (ok > 0) {
            self.onPrivacyOk && self.onPrivacyOk({
              value: self.documentUpload
            });
          } else {
            self.onPrivacyNotOk && self.onPrivacyNotOk({
              value: self.documentUpload
            });
          }
        }
      }

      self.trashCanEnabled = function () {

        return self.documentUpload.some(function (elem) {
          return elem.selected === true;
        })
      }
    }
  });